import React, { Component, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BulletPlot from "./BulletPlot";
import PropTypes from 'prop-types';
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
am4core.useTheme(am4themes_animated);

const DumbbellPlotDesil = (props) => {
	const { id, dataset } = props

	const lineImage = new Image(6, 15)
	lineImage.src = BulletPlot.rectangle({ width: 8, color: '#000000' });

	const poly3Image = new Image(15, 15)
	poly3Image.src = BulletPlot.polygon({ strokeColor: '#000000' });

	const poly4Image = new Image(15, 15)
	poly4Image.src = BulletPlot.polygon({ count: 4, strokeColor: '#F97316' });

	const cubeSmall = []
	const cubeBig = []
	const line = []
	const poly3 = []
	const poly4 = []
	dataset.forEach((item) => {
		cubeSmall.push(...item.children.filter((item) => item.type === 'cube-small').map(detail => { return { x: detail.value, y: item.name } }))
		cubeBig.push(...item.children.filter((item) => item.type === 'cube-big').map(detail => { return { x: detail.value, y: item.name } }))
		line.push(...item.children.filter((item) => item.type === 'line').map(detail => { return { x: detail.value, y: item.name } }))
		poly3.push(...item.children.filter((item) => item.type === '3polygon').map(detail => { return { x: detail.value, y: item.name } }))
		poly4.push(...item.children.filter((item) => item.type === '4polygon').map(detail => { return { x: detail.value, y: item.name } }))
	});
	
	const options = {
		plugins: {
      legend: {
        display: false
      }
    },
		indexAxis: 'y',
		maintainAspectRatio: false,
		scales: {
			y: {
				ticks: {
					autoSkip: false
				}
			},
			x: {
				// min: 0.8
			}
		},
		elements: {
			bar: {
				borderWidth: 0,
			},
		},
		responsive: true,
	}
  const data = {
		labels: dataset.map(item => item.name),
		datasets: [
			{
				label: 'Core Dumbbell',
				data: dataset.map((item) => {
					return { x: [item.start, item.end], y: item.name }
				}),
				backgroundColor: 'rgb(0, 0, 0)',
				borderSkipped: false,
				barThickness: 1
			},
			{
				label: 'Cube Small',
				type: 'scatter',
				data: cubeSmall,
				fill: false,
				backgroundColor: '#271E8A',
				pointStyle: 'rect',
        pointRadius: 4,
			},
			{
				label: 'Cube Big',
				type: 'scatter',
				data: cubeBig,
				fill: false,
				backgroundColor: '#03C46B',
				pointStyle: 'rect',
        pointRadius: 6,
			},
			{
				label: 'Line',
				type: 'scatter',
				data: line,
				pointStyle: lineImage,
			},
			{
				label: 'Polygon 3',
				type: 'scatter',
				data: poly3,
				pointStyle: poly3Image,
			},
			{
				label: 'Polygon 4',
				type: 'scatter',
				data: poly4,
				pointStyle: poly4Image,
			},
		],
	}

	return (
		<div style={{ width: "100%", height: "1100px" }}>
      <Bar data={data} options={options} height={'100%'} />
		</div>
	)
}

export default DumbbellPlotDesil;
